import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const capabilityPillars = [{
  lineColor: "bg-ring",
  // sky highlight
  title: "The strategy survives after the engagement ends.",
  body: "Operating cadence, named owners, and governance hold the work.",
  tagText: "GROWTH STAYS OWNED",
  tagColor: "text-ring"
}, {
  lineColor: "bg-secondary",
  // vibrant orange
  title: "The institution decides its own tech stack.",
  body: "AI governance and data boundaries are set before any platform purchase.",
  tagText: "ENDPOINT STAYS YOURS",
  tagColor: "text-secondary"
}, {
  lineColor: "bg-primary-foreground",
  // solid white
  title: "The next partner is your own team.",
  body: "Cabinet, faculty, and staff run the strategy twelve months and beyond.",
  tagText: "NO SHELF-WARE",
  tagColor: "text-primary-foreground"
}];
export default function CapabilityBanner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section className="bg-primary text-primary-foreground py-16 lg:py-24">
      <div ref={ref} className={`max-w-7xl mx-auto px-6 lg:px-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {/* Header */}
        <div className="max-w-3xl mb-12 lg:mb-16">
          <span className="block text-xs md:text-sm font-semibold uppercase tracking-widest text-ring mb-3">
            WHAT CHANGES WHEN CAPABILITY TRANSFERS
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-secondary">
            Instead of dependency.
          </h2>
        </div>

        {/* 3 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-12">
          {capabilityPillars.map((pillar, idx) => <div key={idx} className="flex flex-col justify-between">
              <div>
                {/* Solid rounded-full accent bar spanning full column width */}
                <div className={`h-1 w-full rounded-full ${pillar.lineColor} mb-6`} aria-hidden="true" />

                <h3 className="text-xl md:text-2xl font-bold tracking-tight text-primary-foreground mb-4 leading-snug">
                  {pillar.title}
                </h3>
                <p className="text-primary-foreground/70 leading-relaxed text-base mb-8">
                  {pillar.body}
                </p>
              </div>

              <div className="pt-2">
                <span className={`inline-block text-xs font-bold uppercase tracking-widest ${pillar.tagColor}`}>
                  {pillar.tagText}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}